import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppBar } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { DetailTabBar } from "../../components/financeDetail";
import { CenterSpinner, EmptyText } from "../../components/managementUi";
import {
  KpiConsultationTab,
  KpiEvaluationTab,
  KpiLeadTab,
  KpiTransactionTab,
} from "../../components/kpiDetailTabs";
import { AttendanceSummaryContent } from "../AttendanceSummary";
import { useEmployeeAuth } from "../../auth/EmployeeAuthContext";
import { getMyKpiDetailApi } from "../../api/evaluation.api";

// Khớp app: app/(feature)/management/statistical-report/my-kpi.tsx
const TABS = [
  { key: "workingDay", title: "Số công" },
  { key: "consultation", title: "Tư vấn" },
  { key: "lead", title: "Leads" },
  { key: "transaction", title: "Giao dịch" },
  { key: "evaluation", title: "Đánh giá" },
];

const MyKpiDetail = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { user } = useEmployeeAuth();
  const code = user?.code;
  const [search] = useSearchParams();
  const hasPeriodParams = !!(search.get("month") && search.get("year"));
  const month = Number(search.get("month")) || new Date().getMonth() + 1;
  const year = Number(search.get("year")) || new Date().getFullYear();
  const attendanceMonth = `${year}-${String(month).padStart(2, "0")}`;

  const [tab, setTab] = useState(0);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;
    setLoading(true);
    getMyKpiDetailApi({ month, year, code })
      .then((d) => setDetail(d || null))
      .catch(() => setDetail(null))
      .finally(() => setLoading(false));
  }, [code, month, year]);

  const activeKey = TABS[tab]?.key;

  const renderTab = () => {
    // Tab "Số công" độc lập với API KPI - luôn hiển thị (khớp app).
    if (activeKey === "workingDay") return <AttendanceSummaryContent month={attendanceMonth} />;

    if (loading) return <CenterSpinner />;
    if (!detail) return <EmptyText text="Không tìm thấy thông tin" />;

    if (activeKey === "consultation") return <KpiConsultationTab data={detail} />;
    if (activeKey === "lead") return <KpiLeadTab data={detail} />;
    if (activeKey === "transaction") return <KpiTransactionTab data={detail} />;
    return <KpiEvaluationTab data={detail} />;
  };

  const pageBody = (
    <>
      <DetailTabBar tabs={TABS} index={tab} onChange={setTab} />
      <Box px={activeKey === "workingDay" ? "0" : "16px"}>{renderTab()}</Box>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage
        title={hasPeriodParams ? `Chi tiết KPI tháng ${month} năm ${year}` : "Chi tiết KPI"}
        right={<DesktopBack onClick={() => navigate(-1)} />}
      >
        <DesktopPanel p="0" pb="24px">
          {pageBody}
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" pb="40px">
      <AppBar title={hasPeriodParams ? `Chi tiết KPI tháng ${month} năm ${year}` : "Chi tiết KPI"} />
      {pageBody}
    </Box>
  );
};

export default MyKpiDetail;
